<template>
  <b-card bg-variant="light"
          header="Experiment reports"
          header-bg-variant="dark"
          header-text-variant="white">
    <experiment_list :elevated="false"
                     :load_data_url="url"
                     :prop_fields="fields"></experiment_list>
  </b-card>
</template>

<script>
  import experiment_list from '@/components/proposal/experiment-report/experiment_list';
  import { ordinalNumber } from '@/helpers/commonTableColumns';

  export default {
    name: 'experiment_dashboard',
    components: { experiment_list },
    data() {
      return {
        url: '/documents/experiment-reports/me',
        fields: [
          ordinalNumber,
          {
            key: 'document_specification.document_id',
            label: 'ID',
            sortable: true,
            class: 'custom-column-id-width',
          },
          {
            key: 'title',
            label: 'Title',
            class: 'custom-break-col-lg',
          },
          {
            key: 'author',
            label: 'Author',
            class: 'custom-break-col-md',
            thStyle: { width: '10%' },
          },
          {
            key: 'document_specification.type',
            label: 'Infrastructure',
          },
          {
            key: 'states.date',
            label: 'Proposal submission date',
            sortable: true,
          },
          {
            key: 'experiment_report.states.date',
            label: 'Report submission date',
            sortable: true,
          },
          {
            key: 'experiment_report.states.name',
            label: 'Report status',
          },
          {
            key: 'actions',
            label: 'Actions',
          },
        ],
      };
    },
  };
</script>

<style scoped>
  .card {
    margin: 2rem;
  }
</style>
